var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "41px",
    viewBox: "0 0 48 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 46.2698413 0 46.2698413 40.2858092 0 40.2858092"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.00465607681 19.7478826 0.00465607681 19.7478826 21.1922124 0 21.1922124"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.050977207 0.0603136236 20.5485013 0.0603136236 20.5485013 34.0249064 0.050977207 34.0249064"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "12.6190476 36.89332 47.531746 36.89332 47.531746 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "servicios-copy-7",
    transform: "translate(-407.000000, -325.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(141.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(261.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(5.468254, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2198795,1.95193431 C38.24339,0.143256455 35.9892785,-0.529266617 34.185049,0.449630457 C33.9982572,0.55096955 33.8242886,0.666663229 33.6625021,0.793712029 C33.1066147,1.12408176 27.2506695,5.85231103 22.9835235,3.36982462 C20.911502,2.22188622 18.3184296,2.12161837 16.0820569,3.33511651 C14.1147586,4.40249783 12.8441894,6.2572389 12.4481651,8.29901809 L11.4039261,12.3765775 C10.9397249,14.3532255 9.88223526,16.1396216 8.37379507,17.4951659 L3.94571738,21.4739572 C3.64116549,21.7186279 3.35307008,21.9782959 3.08143117,22.2508188 L3.07074514,22.26046 L3.07117258,22.2611027 C-0.129721265,25.4816719 -0.996999572,30.5434846 1.27228605,34.7468074 C4.04317399,39.8791076 10.4396187,41.7876248 15.5590826,39.0101195 C16.0679514,38.7339544 16.5445484,38.4213672 16.9882324,38.0783569 L21.8454611,34.9122065 C24.5056418,33.1780868 27.8343405,32.8269351 30.7965084,33.9671606 C31.5911217,34.2731061 32.5956087,34.781087 32.7505561,34.8974234 C32.7518385,34.8982804 32.7556854,34.8963522 32.7580364,34.8961379 C35.3733357,36.4511467 38.7140028,36.6302576 41.5825611,35.0737492 C45.925578,32.7174546 47.5408785,27.2777092 45.1901653,22.9239846 C45.1581072,22.8646381 40.1262687,14.3185174 40.1262687,14.3185174 C40.1192159,14.306091 40.1119494,14.2934504 40.1046829,14.281024 C38.923449,12.229818 38.531058,9.81589078 38.9775204,7.49023358 L39.5716637,4.56189801 C39.7685004,3.70855 39.6684791,2.78278632 39.2198795,1.95193431",
    id: "Fill-1",
    fill: "#5A9CA7",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(13.946328, 24.098337) rotate(9.000000) translate(-13.946328, -24.098337) translate(2.749145, 6.200032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7478826,21.1922124 C19.5885942,16.6422225 18.3143573,15.3494807 16.9604056,11.3095819 C15.6065245,7.26968316 13.6951339,5.25897429 10.350218,2.83043626 C7.00523143,0.401826592 2.14933478,-0.982962284 0.79432398,0.840643924 C-0.56068682,2.6641785 -0.87926369,7.75441657 5.65135034,13.3295313 C11.6244548,18.096566 15.2879476,17.0967273 19.7478826,21.1922124",
    id: "Fill-1",
    fill: "#2BA15A",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.841270, 1.272183)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4428482,24.5508324 L20.4428482,21.7183564 C20.4499774,21.6209377 20.9201507,24.2182121 18.7324083,19.9557867 C14.8470021,13.5611816 7.68901735,6.00399917 0.050977207,0.232658728 L0.177467314,0.0603136236 C7.83689502,5.84784276 15.0166203,13.4293799 18.9146614,19.8463339 C21.1359321,24.1679268 20.8672654,22.7162453 20.8600656,22.8143086 L20.4428482,24.5508324 Z",
    id: "Fill-4",
    fill: "#1F573B",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.69875943,6.36091725 C6.50052419,6.33233489 1.83266308,5.65022665 0.841269841,4.82957636 L0.980396252,4.66467265 C1.92512463,5.44664005 6.68211924,6.14142768 6.73015873,6.14830464 L6.69875943,6.36091725 Z",
    id: "Fill-7",
    fill: "#1F573B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04129331,8.90528415 C4.03915513,8.90528415 3.09611614,8.85476667 2.52380952,8.70298871 L2.57526474,8.48415482 C4.21560336,8.91919149 9.18637577,8.48565831 9.23641544,8.481223 L9.25396825,8.70592053 C9.11864173,8.7179485 6.97089944,8.90528415 5.04129331,8.90528415",
    id: "Fill-9",
    fill: "#1F573B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9024606,9.75340645 C9.89681928,9.7057304 9.33534591,4.97294267 8.83333333,3.47415511 L9.01469851,3.3924892 C9.52494611,4.91601716 10.0721541,9.52720842 10.0952381,9.72280053 L9.9024606,9.75340645 Z",
    id: "Fill-11",
    fill: "#1F573B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0758691,13.5699568 C14.0705759,13.5201093 13.5432194,8.56416683 13.0396825,6.84068615 L13.2585952,6.7849784 C13.7669716,8.52554561 14.2962941,13.4990689 14.3015873,13.5491282 L14.0758691,13.5699568 Z",
    id: "Fill-13",
    fill: "#1F573B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1632405,17.3865071 C15.6308625,16.674537 11.4047038,16.7749499 11.3621456,16.7758733 L11.3571429,16.5451158 C11.5325899,16.5405761 15.6720115,16.4427023 17.2460317,17.1740626 L17.1632405,17.3865071 Z",
    id: "Fill-15",
    fill: "#1F573B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(5.225352, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1904762,8.05716185 C20.1904762,7.58866361 20.5105952,7.20903955 20.905629,7.20903955 L40.9280191,7.20903955 C41.3227381,7.20903955 41.6428571,7.58866361 41.6428571,8.05716185 C41.6428571,8.52566009 41.3227381,8.90528415 40.9280191,8.90528415 L20.905629,8.90528415 C20.5105952,8.90528415 20.1904762,8.52566009 20.1904762,8.05716185",
    id: "Fill-16",
    fill: "#BBBBBB",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.452381,17.8105683 C21.452381,17.3420701 21.8415224,16.962446 22.3217662,16.962446 L46.6626739,16.962446 C47.1426046,16.962446 47.531746,17.3420701 47.531746,17.8105683 C47.531746,18.2790665 47.1426046,18.6586906 46.6626739,18.6586906 L22.3217662,18.6586906 C21.8415224,18.6586906 21.452381,18.2790665 21.452381,17.8105683",
    id: "Fill-17",
    fill: "#BBBBBB",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.984127,22.4752409 C15.984127,22.0067427 16.3732684,21.6271186 16.8535122,21.6271186 L41.1944199,21.6271186 C41.6743506,21.6271186 42.0634921,22.0067427 42.0634921,22.4752409 C42.0634921,22.9434338 41.6743506,23.3233632 41.1944199,23.3233632 L16.8535122,23.3233632 C16.3732684,23.3233632 15.984127,22.9434338 15.984127,22.4752409",
    id: "Fill-18",
    fill: "#BBBBBB",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8261213,12.1234183 C41.0325062,18.7212933 39.9476722,28.3247788 33.4031051,33.5735716 C26.858538,38.8223644 17.3326445,37.728694 12.1262597,31.130819 C6.9198748,24.532944 8.00470878,14.9294585 14.5492758,9.68066569 C21.0938429,4.43187287 30.6197364,5.52554324 35.8261213,12.1234183",
    id: "Fill-19",
    fill: "#084C7C",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.476192,13.707379 C37.7425277,19.2057139 36.8537077,27.2084677 31.4906955,31.5824541 C26.1276832,35.9564404 18.3218897,35.0451933 14.055554,29.5468583 C9.78921835,24.0485234 10.6780383,16.0457696 16.0410506,11.6717832 C21.4040628,7.29779686 29.2098563,8.20904401 33.476192,13.707379 L68.4791333,17.7096258",
    id: "Fill-20",
    fill: "#FFFFFF",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5751996,12.4578088 C17.7197277,12.6411619 17.6897959,12.9078572 17.5079242,13.0535626 C17.3260526,13.1995553 17.061512,13.1690922 16.9169839,12.9857392 C16.7721708,12.8023861 16.8023877,12.5356907 16.9842593,12.3899854 C17.1658459,12.2442801 17.4306715,12.2744557 17.5751996,12.4578088",
    id: "Fill-21",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0350183,16.9920926 C14.2510812,17.0779981 14.3574024,17.3239348 14.2721745,17.5417151 C14.1872315,17.7597828 13.9429493,17.8666618 13.7268864,17.7810437 C13.5108235,17.6951382 13.4045023,17.4489143 13.4897303,17.2311339 C13.5746732,17.0133535 13.8189554,16.9061872 14.0350183,16.9920926",
    id: "Fill-22",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9775368,22.479929 C13.207305,22.445439 13.4213942,22.6049551 13.4556029,22.8366127 C13.4900966,23.0682703 13.3315965,23.28412 13.1018283,23.3186099 C12.8720601,23.3533873 12.6579708,23.1935838 12.6237622,22.9619262 C12.5892684,22.7302686 12.7477686,22.514419 12.9775368,22.479929",
    id: "Fill-23",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3016222,28.080248 C15.4835198,27.9345426 15.7480982,27.9647183 15.8926469,28.1480713 C16.0371956,28.3314244 16.0072595,28.5981198 15.8253619,28.7438251 C15.6434643,28.8898178 15.378886,28.8593548 15.2343372,28.6760017 C15.0897885,28.492936 15.1197246,28.2259533 15.3016222,28.080248",
    id: "Fill-24",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7992483,31.6492539 C19.8844593,31.4314404 20.1284078,31.3242577 20.3447127,31.4101763 C20.5607325,31.4960948 20.6667475,31.7420689 20.5818215,31.9598824 C20.4966105,32.1779832 20.252377,32.2848785 20.0363571,32.19896 C19.8203373,32.1133288 19.7140373,31.8670674 19.7992483,31.6492539",
    id: "Fill-25",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2427442,32.2912993 C25.2085416,32.0596596 25.3667287,31.8438265 25.5964563,31.8093392 C25.8261838,31.7745645 26.0402352,31.9343557 26.0747228,32.1659954 C26.1089254,32.3976352 25.9504533,32.6134683 25.7207258,32.6479556 C25.4912832,32.6827303 25.2769468,32.5229391 25.2427442,32.2912993",
    id: "Fill-26",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3771944,30.3723445 C30.2326457,30.1889653 30.2625818,29.9222318 30.4444794,29.7765057 C30.626377,29.6307796 30.8909553,29.6609596 31.035504,29.8443388 C31.1800528,30.027718 31.1501166,30.2944514 30.968219,30.4401776 C30.7863214,30.5859037 30.5217431,30.5557237 30.3771944,30.3723445",
    id: "Fill-27",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9173512,25.8380835 C33.7012976,25.752178 33.5949809,25.5062414 33.6802052,25.288461 C33.7654296,25.0703933 34.0094163,24.9635143 34.22547,25.0491325 C34.4418087,25.1350379 34.5478403,25.3812619 34.462616,25.5990422 C34.3776766,25.8168226 34.1334049,25.9239889 33.9173512,25.8380835",
    id: "Fill-28",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9748813,20.3501822 C34.7450954,20.3849569 34.5309897,20.2251657 34.4967784,19.993526 C34.462282,19.7618862 34.6207944,19.5460532 34.8505803,19.5115659 C35.0803662,19.4767912 35.2944719,19.6365823 35.3286832,19.8682221 C35.3628945,20.0998619 35.2046672,20.3156949 34.9748813,20.3501822",
    id: "Fill-29",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6507814,14.7499282 C32.4689097,14.8956335 32.2043691,14.8654579 32.0598411,14.6821048 C31.9150279,14.4987517 31.9452448,14.2320564 32.1271165,14.086351 C32.3089881,13.9403583 32.5735287,13.9708214 32.7180568,14.1541744 C32.8625849,14.3372401 32.832653,14.6042228 32.6507814,14.7499282",
    id: "Fill-30",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1531326,11.1809108 C28.0679212,11.3987336 27.8239716,11.5059208 27.6079508,11.4199986 C27.391645,11.3343638 27.2856295,11.0880918 27.3705559,10.870269 C27.4557673,10.6524462 27.7000019,10.545259 27.9160227,10.6311812 C28.1320435,10.716816 28.2383439,10.963088 28.1531326,11.1809108",
    id: "Fill-31",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7096355,10.5388393 C22.7438468,10.7704969 22.5856196,10.9863466 22.3558337,11.0208366 C22.1260478,11.055614 21.9119421,10.8958105 21.8777308,10.6641529 C21.8432344,10.4324953 22.0017468,10.2166456 22.2315326,10.1821556 C22.4610334,10.1476657 22.6751391,10.3071818 22.7096355,10.5388393",
    id: "Fill-32",
    fill: "#FF3D00",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#000000",
    mask: "url(#mask-8)",
    points: "23.834567 20.7789963 23.9761905 21.6790445 18.2289251 22.4752409 18.0873016 21.5748969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1743904,21.6174076 C36.1743904,21.6148633 36.1743904,21.612743 36.1743904,21.6106227 C36.1743904,14.5936828 30.5551918,8.90532655 23.6232157,8.90532655 C23.6006623,8.90532655 23.5781089,8.9070228 23.5555556,8.9070228 L23.5555556,21.6174076 L36.1743904,21.6174076 Z",
    fill: "#F9C200",
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#000000",
    mask: "url(#mask-8)",
    points: "24.1799788 21.6271186 23.5555556 21.3457374 26.7168466 13.1458956 27.3412698 13.4272769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.622091,19.883082 C26.3450693,20.7994586 26.1944738,22.1331949 25.2855011,22.8623645 C24.3765284,23.5912317 23.0535682,23.4394096 22.3302899,22.523033 C21.6073117,21.6066564 21.7579071,20.2729201 22.6668798,19.5437505 C23.5758525,18.8148833 24.8991127,18.9667054 25.622091,19.883082",
    id: "Fill-35",
    fill: "#000000",
    mask: "url(#mask-8)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.0622bff94bb36066efad570d296d0c25.svg";
export { ForwardRef as ReactComponent };